import { ILevelGeneralDto } from './level-general-dto';

export const levelGeneralData = {
    guid: 'guid',
    deleted: 'deleted',
    inactive: 'inactive',
} as const;

export type TLevelGeneralData = (typeof levelGeneralData)[keyof typeof levelGeneralData];

export interface ILevelGeneralData extends ILevelGeneralDto
{
    [levelGeneralData.guid]: string;
    [levelGeneralData.deleted]: boolean;
    [levelGeneralData.inactive]: boolean;

}

export class LevelGeneralData
    implements ILevelGeneralData, ILevelGeneralDto
{
    [levelGeneralData.guid]!: string;
    [levelGeneralData.deleted]!: boolean;
    [levelGeneralData.inactive]!: boolean;
}
